// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__L7LrI","waveWrap":"styles_waveWrap__RibJR","path":"styles_path__EvBmP"};